export default __webpack_public_path__ + "static/media/condense.02869eee.svg";